import { type RegionCookieSettings } from "./types";

export const STATE_COOKIE_NAME = "state";
export const COUNTRY_COOKIE_NAME = "country";
export const COOKIE_SETTINGS_TTL = 365 * 5; // Five Years in days
export const CCPA_ENABLED_CROSS_DOMAIN_COOKIE = "ccpa_enabled";
export const GOOGLE_TAG_MANAGER_CONSENT_COOKIE_NAME = "gtm_consent";

export const INITIAL_COOKIES: RegionCookieSettings = {
  _settingsEffectiveRegion: "",
  hasDismissed: false,
  allowAnalytics: true,
  enableOptOutCcpa: false
};
